import { useEffect, useState } from "react";

const STORAGE_KEY = "manucalc.calculatorMode.v1";

const getStoredMode = () => {
  if (typeof window === "undefined") return "beginner";
  return window.localStorage.getItem(STORAGE_KEY) || "beginner";
};

const useCalculatorMode = () => {
  const [mode, setMode] = useState(getStoredMode);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, mode);
    }
  }, [mode]);

  return {
    mode,
    isAdvanced: mode === "advanced",
    setMode,
    toggleMode: () => setMode((current) => (current === "advanced" ? "beginner" : "advanced")),
  };
};

export default useCalculatorMode;
